module.exports = __webpack_public_path__ + "img/symbol_15.5f29d8c3.png";